import { createSlice } from '@reduxjs/toolkit';

const initialState = { allPlayLists: { allPlayLists: [], playlistCount: 0 }, status: 'idle' };

const allPlayListsSlice = createSlice({
  name: 'allPlayLists',
  initialState,
  reducers: {
    allPlayListsHandler(state, action) {
      state.allPlayLists = action.payload.allPlayLists;
      state.status = 'done';
    },
    resetPlaylist: () => initialState
  },
});
export const allPlayListsAction = allPlayListsSlice.actions;
export default allPlayListsSlice;